module.exports = __webpack_public_path__ + "img/hazardEquip40.d2b4b7e0.jpg";